import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { tenderRegistrationsApi } from "../../../api/tenderRegistrations";
import { notifications } from "@mantine/notifications";

export function useTenderRegistrations() {
  return useQuery({
    queryKey: ["vendor", "registrations"],
    queryFn: () => tenderRegistrationsApi.listRegistrations(),
  });
}

export function useTenderRegistrationStatus(tenderId: string) {
  return useQuery({
    queryKey: ["vendor", "registration-status", tenderId],
    queryFn: () => tenderRegistrationsApi.getRegistrationStatus(tenderId),
    enabled: !!tenderId,
  });
}

export function useRegisterForTender() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tenderId: string) => tenderRegistrationsApi.registerForTender(tenderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor", "registrations"] });
      queryClient.invalidateQueries({ queryKey: ["vendor", "registration-status"] });
      notifications.show({
        title: "Success",
        message: "Successfully registered for tender",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.response?.data?.error || "Failed to register for tender",
        color: "red",
      });
    },
  });
}

export function useWithdrawFromTender() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tenderId: string) => tenderRegistrationsApi.withdrawFromTender(tenderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor", "registrations"] });
      queryClient.invalidateQueries({ queryKey: ["vendor", "registration-status"] });
      notifications.show({
        title: "Success",
        message: "Successfully withdrawn from tender",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.response?.data?.error || "Failed to withdraw from tender",
        color: "red",
      });
    },
  });
}

